import { LocationActivityLogModel } from "../../app/data/door-master/models";
import { LastIdsPaginationModel } from "../../app/data/common/models";
import { BaseState } from "..";

export default interface LocationActivityLogState extends BaseState {
  loading: boolean;
  loadingFail: boolean;
  loadingFailed: boolean;
  loaded: boolean;
  requestStarted: boolean;
  fetchPortionStarted: boolean;
  requestCreator: string;
  requestSucceed: boolean;
  requestFailed: boolean;
  requestResponseCode: number;
  requestError: string;
  pickupsFetchedAll: boolean;
  locationActivityLogs: LocationActivityLogModel[];
  locationActivityLogsRequest: {
    page: number,
    last: boolean
  };
  loadedLocationActivityLogPages: LastIdsPaginationModel[];
}

export const initialLocationActivityLogState: LocationActivityLogState = {
  loading: false,
  loadingFail: false,
  loadingFailed: false,
  loaded: false,
  requestStarted: false,
  fetchPortionStarted: false,
  requestCreator: "",
  requestSucceed: false,
  requestFailed: false,
  requestResponseCode: 0,
  requestError: "",
  pickupsFetchedAll: false,
  locationActivityLogs: [],
  locationActivityLogsRequest: {
    page: 0,
    last: false
  },
  loadedLocationActivityLogPages: [],
};

